import { CacheStrategy } from '@rammetec/data-access';
import { AUDIT_FIELD_DESCRIPTORS, AUDIT_FOREIGN_KEYS } from './_auditFields.js';
import { BUSINESS_ALLOWED_DATA_SOURCES, BUSINESS_DEFAULT_DATA_SOURCE } from './dataSourcePolicy.js';
import { SIZE_OCCURRENCE } from '../types/size-occurrence.js';
import { FIELD_LIMITS } from '../validation/fieldLimits.js';
/**
 * Descriptor for SizeOccurrence (tamanho de uma grade).
 * Subcollection: org/{orgId}/size-grid/{sizeGridId}/occurrence
 *
 * Resolve repository with context: { orgId, sizeGridId }.
 * No lifecycle.
 */
export const sizeOccurrenceDescriptor = {
    name: SIZE_OCCURRENCE,
    label: 'Tamanho da grade',
    domain: 'catalog',
    collectionPath: 'org/{orgId}/size-grid/{sizeGridId}/occurrence',
    pathPatternKeys: {
        orgId: 'string',
        sizeGridId: 'string',
    },
    version: 1,
    description: 'Tamanho (label/sortOrder) dentro de uma SizeGrid',
    repositoryConfig: {
        dataSource: BUSINESS_DEFAULT_DATA_SOURCE,
        // NoCache: child of versioned SizeGrid (spec 0045) — Recarregar must not re-serve stale rows.
        cache: CacheStrategy.NoCache,
    },
    allowedDataSources: BUSINESS_ALLOWED_DATA_SOURCES,
    fields: [
        {
            name: 'id',
            label: 'ID',
            type: 'string',
            required: true,
            description: 'Unique size occurrence identifier',
        },
        {
            name: 'label',
            label: 'Tamanho',
            type: 'string',
            required: true,
            maxLength: FIELD_LIMITS.ABBREVIATION,
            description: 'Display label (e.g. 38, P, 2–4 anos)',
        },
        {
            name: 'sortOrder',
            label: 'Ordem',
            type: 'number',
            required: true,
            description: 'Display order within the grid (0..MAX_SIZE_ORDER)',
        },
        ...AUDIT_FIELD_DESCRIPTORS,
    ],
    foreignKeys: [...AUDIT_FOREIGN_KEYS],
};
//# sourceMappingURL=size-occurrence.descriptor.js.map